import { ActionPointInfo, Controller, CustomArgs, IActionPointInfo, Menu, Toolbar } from '@tencent/workbench';
import { RatingFeature } from './rating-feature';
import { INSERT_TEXT_MENU_CONFIGS, config, TOOLBAR_ITEMS, toolbarConfig } from './config';

@Controller({
    menuItems: INSERT_TEXT_MENU_CONFIGS,
    toolbarItems: TOOLBAR_ITEMS,
})
export class RatingController {
    public constructor(private readonly feature: RatingFeature) {
    }

    @Menu(config.id, 'onClick')
    @Toolbar(toolbarConfig.id, 'onClick', { reportConfig: toolbarConfig })
    public onClick(@CustomArgs() args: { reportConfig?: any }) {
        // 排版检查和 AI 区域有重叠，手动关闭 AI 助手
        this.feature.getAppService().editableServiceLayer?.aiService?.promise().then((aiService) => {
            aiService.hideSideBar();
        });
        this.feature.getAppService()
            .editableServiceLayer?.ratingService?.promise().then((ratingService) => {
                ratingService.showDrawer();
            });
        if (args?.reportConfig) {
            this.feature.twdReport(undefined, undefined, args.reportConfig);
        }
    }

    @Menu(config.id, 'content')
    public getMenuRatingContent(@ActionPointInfo() info:  IActionPointInfo) {
        return this.feature.getMenuRatingContent(info);
    }
}
